export default __webpack_public_path__ + "static/media/General Savings.67a339a5.svg";